app.controller('CIF2-CTRL', ['$scope', '$window', '$q', '$filter', '$http', '$timeout',
    function ($scope, $window, $q, $filter, $http, $timeout) {

        $scope.listBankRDN = ['BCA (Online)', 'MANDIRI (Offline)', 'CIMB (Offline)', 'MAYAPADA (Offline)'];
        $scope.rdnbca = $scope.listBankRDN[0];
        $scope.bankRDN = '';
        $scope.PhoneCode = '+62';
        $scope.CIFInvestor = {}
        $scope.CIFInvestor.HomePhoneCode = '021';
        $scope.bankpribadi = '';

        $scope.OPBBCA = {
            occupation: '',
            occupationText: '',
            position: '',
            positionText: '',
            business: '',
            businessText: ''
        }

        $scope.CIFInvestor = {
            occupation: '',
            occupationText: '',
            position: '',
            positionText: '',
            business: '',
            businessText: ''
        }

        $scope.OPBOTHER = {
            occupation: '',
            occupationText: '',
            position: '',
            positionText: '',
            business: '',
            businessText: ''
        }

        $scope.OPSPOUSE = {
            occupation: '',
            occupationText: '',
            position: '',
            business: '',
        }

        $scope.disableBank = true;
        $scope.disableCIFInvestorQuestionRDN = false;

        $scope.selectedFundSource = [];
        $scope.selectedSpouseFundSource = [];

        $scope.fundsource1 = [
      {
          id: 1,
          name: 'Lainnya'
      },
      {
          id: 2,
          name: 'Gaji'
      },
      {
          id: 3,
          name: 'Hasil Usaha'
      },
      //{
      //    id: 4,
      //    name: 'Tabungan'
      //},
       {
           id: 5,
           name: 'Warisan'
       }
        ];

        $scope.spousefundsource1 = [
      {
          id: 1,
          name: 'Lainnya'
      },
      {
          id: 2,
          name: 'Gaji'
      },
      {
          id: 3,
          name: 'Hasil Usaha'
      },
      //{
      //    id: 4,
      //    name: 'Tabungan'
      //},
       {
           id: 5,
           name: 'Warisan'
       }
        ];

        $scope.ListBank = {};
        $scope.listpekerjaan_BCA = {};
        $scope.listjabatan_BCA = {};
        $scope.listusaha_BCA = {};
        $scope.listpekerjaan_PERMATA = {};
        $scope.listjabatan_PERMATA = {};
        $scope.listusaha_PERMATA = {};
        $scope.ListLookup = [];
        $scope.ListOccupation = [];
        $scope.ListSpouseIncome = [];

        $scope.ListKecamatanCompany = [];
        $scope.ListKelurahanCompany = [];


        $scope.CompanyCitySelected = '';
        $scope.SpouseCompanyCitySelected = '';
        $scope.mustSelect = function (event, field) {

            if (event.keyCode == 27) {

                let returnValue = true;
                switch (field) {

                    case 'CompanyCity': $scope.CIFInvestor.CompanyCity = ''; returnValue = false;
                        break;
                    default:
                        break;
                }
                return returnValue;
            }
            return true;
        }
        $scope.selectCity = function (item, model, label, event) {

            if (item.CIFProvinceCityNID) {

                $scope.CIFInvestor.SpouseCompanyCity = item.CIFProvinceCityNID;
            }
        };

        $scope.selectCompanyCity = function (item, model, label, event) {
            $scope.ListKecamatanCompany = '';
            $scope.ListKelurahanCompany = '';

            if (item.CIFProvinceCityNID) {
                $scope.CIFInvestor.CompanyCity = item.CIFProvinceCityNID;
                $http({
                    method: 'GET',
                    url: '/service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + item.CIFProvinceCityNID,
                    cache: true,
                }).then(function (data) {
                        $scope.ListKecamatanCompany = data.data.d;
                        $scope.kecamatanChangeCompanyCity();
                }, function (error) { });
            }

        };


        $scope.kecamatanChangeCompanyCity = function () {
            if ($scope.CIFInvestor.CompanyKecamatan) {
                $scope.ListKelurahanCompany = $filter('filter')($scope.ListKecamatanCompany, { Kecamatan: $scope.CIFInvestor.CompanyKecamatan }, true);
            }
        }

        $scope.kelurahanChangeCompanyCity = function () {
            if ($scope.CIFInvestor.CompanyKelurahan) {
                let temp = $filter('filter')($scope.ListKecamatanCompany, { Kelurahan: $scope.CIFInvestor.CompanyKelurahan }, true);
                if (temp) {
                    $scope.CIFInvestor.CompanyPostalCode = temp[0].PostalCode;
                }
            }
        }


        $scope.questionRDNchange = function () {

            $scope.OPBBCA.occupation = '';
            $scope.OPBBCA.occupationText = '';
            $scope.OPBBCA.position = '';
            $scope.OPBBCA.positionText = '';
            $scope.OPBBCA.business = '';
            $scope.OPBBCA.businessText = '';

            $scope.CIFInvestor.occupation = '';
            $scope.CIFInvestor.occupationText = '';
            $scope.CIFInvestor.position = '';
            $scope.CIFInvestor.positionText = '';

            $scope.OPBOTHER.occupation = '';
            $scope.OPBOTHER.occupationText = '';
            $scope.OPBOTHER.position = '';
            $scope.OPBOTHER.positionText = '';
            $scope.OPBOTHER.business = '';
            $scope.OPBOTHER.businessText = '';

            $scope.CIFInvestor.BankName = "";
            $scope.disableBank = false;

            if ($scope.CIFInvestor.QuestionRDN == '1' || $scope.CIFInvestor.QuestionRDN == 1) {

                $scope.bankpribadi = "PT. BANK CENTRAL ASIA, Tbk.";
                $scope.disableBank = true;
            }
        };


        $scope.changeSpouseMandatory = function (param) {

            if (param) {

                $scope.spouseMandatory = true;
            } else {
                let flag = false;

                if ($scope.OPBBCA) {

                    if ($scope.OPBBCA.occupation.key == 1 || $scope.OPBBCA.occupation.key == 2) {

                        flag = true;
                        $scope.spouseMandatory2 = true;
                        $scope.spouseMandatory1 = false
                    }
                }

                if ($scope.CIFInvestor.QuestionRDN == '2') {
                    if ($scope.CIFInvestor.Occupation.key == 3 || $scope.CIFInvestor.Occupation.key == 4) {

                        flag = true;
                        $scope.spouseMandatory2 = true;
                        $scope.spouseMandatory1 = false
                    }
                }

                if ($scope.OPBOTHER) {

                    if ($scope.OPBOTHER.CIFLookupInteger == 4 || $scope.OPBOTHER.CIFLookupInteger == 6) {

                        flag = true;
                        $scope.spouseMandatory2 = true;
                        $scope.spouseMandatory1 = false;
                    }

                }


                if ($scope.selectedFundSource.indexOf(7) > -1) {

                    flag = true;
                    $scope.spouseMandatory2 = true;
                    $scope.spouseMandatory1 = false;
                }

                if ($scope.selectedFundSource.indexOf(6) > -1) {

                    flag = true;
                    $scope.spouseMandatory1 = true;
                    $scope.spouseMandatory2 = false;
                }

                if (!flag) {

                    $scope.CIFInvestor.SpouseCompanyName = '';
                    $scope.CIFInvestor.SpouseIncomePerAnnum = '';
                    $scope.CIFInvestor.SpouseIncomeExtraPerAnnum = '';
                    $scope.CIFInvestor.SpouseOccupation = '';
                    $scope.CIFInvestor.SpousePosition = '';
                    $scope.CIFInvestor.SpouseNatureOfBusiness = '';
                    $scope.CIFInvestor.SpouseCompanyCity = '';
                    $scope.CIFInvestor.SpouseCompanyPostalCode = '';
                    $scope.CIFInvestor.SpouseCompanyAddress = '';
                    $scope.CIFInvestor.SpouseFundSource = '';

                    $scope.SpouseCompanyCitySelected = '';
                    $scope.selectedSpouseFundSource = [];

                    $scope.OPSPOUSE.occupation = '';
                    $scope.OPSPOUSE.occupationText = '';
                    $scope.OPSPOUSE.position = '';
                    $scope.OPSPOUSE.business = '';
                }

                $scope.spouseMandatory = flag;
            }
        }

        $scope.bo = function () {

            if ($scope.CIFInvestor.QuestionNPWP == 2) {
                var SWALtranslate = $scope.SWALtranslate('npwp');

                Swal.fire({
                    text: SWALtranslate.message,
                    imageAlt: 'BO',
                    imageHeight: 250,
                    animation: false
                });
            }
        }

        $scope.updateNPWP = function () {

            if ($scope.CIFInvestor.NPWPNumber) {

                if ($scope.CIFInvestor.QuestionNPWP == 1) {

                    $scope.CIFInvestor.NPWPNumber;
                } else {
                    $scope.CIFInvestor.NPWPReason;
                    $scope.CIFInvestor.NPWPNumber = '';

                }
            }
        };

        $scope.occupationChange_BCA = function () {

            if ($scope.OPBBCA.occupation) {

                $scope.OPBBCA.occupationText = '';
                $scope.OPBBCA.position = 0;
                $scope.OPBBCA.positionText = '';
                $scope.OPBBCA.business = 0;
                $scope.OPBBCA.businessText = '';

                if ($scope.OPBBCA.occupation.key == 1 || $scope.OPBBCA.occupation.key == 2)
                    $scope.changeSpouseMandatory(true);
                else
                    $scope.changeSpouseMandatory();
                $http({
                    method: 'GET',
                    url: '/service/client.svc/GetJabatan?Pekerjaan=' + $scope.OPBBCA.occupation.key,
                }).then(function (data) {
               

                        $scope.listjabatan_BCA = data.data.d;

                        if ($scope.listjabatan_BCA.length) {
                            $scope.OPBBCA.positionText = '';
                            $scope.OPBBCA.position = $scope.listjabatan_BCA[0];

                            $scope.positionChange_BCA();
                        }
                }, function (error) { });
            }
        };

        $scope.positionChange_BCA = function () {
            $http({
                method: 'GET',
                url: '/service/client.svc/GetBidangUsaha?Jabatan=' + $scope.OPBBCA.position.key + '&Pekerjaan=' + $scope.OPBBCA.occupation.key,
            }).then(function (data) {

                    $scope.listusaha_BCA = data.data.d;

                    if ($scope.listusaha_BCA.length) {

                        $scope.OPBBCA.businessText = '';
                        $scope.OPBBCA.business = $scope.listusaha_BCA[0];
                    }
            }, function (error) { });
        };

        $scope.occupationChange_PERMATA = function () {

            if ($scope.CIFInvestor.Occupation) {

                $scope.CIFInvestor.OccupationText = '';
                $scope.CIFInvestor.Position = 0;
                $scope.CIFInvestor.PositionText = '';
                $scope.CIFInvestor.NatureOfBusiness = 0;
                $scope.CIFInvestor.NatureOfBusinessText = '';

                if ($scope.CIFInvestor.Occupation.key == 3 || $scope.CIFInvestor.Occupation.key == 4)
                    $scope.changeSpouseMandatory(true);
                else
                    $scope.changeSpouseMandatory();

                $http({
                    method: 'GET',
                    url: '/service/client.svc/GetJabatanPermata?Pekerjaan=' + $scope.CIFInvestor.Occupation.key,
                }).then(function (data) {

                        $scope.listjabatan_PERMATA = data.data.d;

                        if ($scope.listjabatan_PERMATA.length) {
                            $scope.CIFInvestor.PositionText = '';
                            $scope.CIFInvestor.Position = $scope.listjabatan_PERMATA[0];

                            $scope.positionChange_PERMATA();
                        }
                }, function (error) { });
            }
        };

        $scope.occupationChange_OTHER = function () {

            if ($scope.OPBOTHER.occupation) {

                $scope.OPBOTHER.occupationText = '';
                $scope.OPBOTHER.position = '';
                $scope.OPBOTHER.positionText = '';
                $scope.OPBOTHER.business = '';
                $scope.OPBOTHER.businessText = '';

                if ($scope.OPBOTHER.occupation == '4' || $scope.OPBOTHER.occupation == '6')
                    $scope.changeSpouseMandatory(true);
                else
                    $scope.changeSpouseMandatory();
            }
        }

        $scope.toggleFundSourceItem = function (fundsource) {

            let indexCIFLookupInteger = $scope.selectedFundSource.indexOf(fundsource.id);

            if (indexCIFLookupInteger > -1)
                $scope.selectedFundSource.splice(indexCIFLookupInteger, 1);
            else
                $scope.selectedFundSource.push(fundsource.id);

            if ($scope.selectedFundSource.indexOf(1) < 0)
                $scope.CIFInvestor.FundSourceText = '';

            $scope.changeSpouseMandatory();
        }

        $scope.toggleSpouseFundSourceItem = function (fundsource) {

            $scope.CIFInvestor.SpouseFundSource = '';
            let indexCIFLookupInteger = $scope.selectedSpouseFundSource.indexOf(fundsource.id);

            if (indexCIFLookupInteger > -1)
                $scope.selectedSpouseFundSource.splice(indexCIFLookupInteger, 1);
            else
                $scope.selectedSpouseFundSource.push(fundsource.id);

            if ($scope.selectedSpouseFundSource.indexOf(1) < 0)
                $scope.CIFInvestor.SpouseFundSourceText = '';
        }


        $scope.prepareData = function () {

            if ($scope.CIFInvestor.IncomeExtraPerAnnum == '') {
                $scope.CIFInvestor.IncomeExtraPerAnnum == 0;
            }


            if ($scope.CIFInvestor.QuestionRDN == '1' || $scope.CIFInvestor.QuestionRDN == 1) {

                $scope.CIFInvestor.BankName = $scope.bankpribadi;
                $scope.CIFInvestor.Occupation = $scope.OPBBCA.occupation.key;
                $scope.CIFInvestor.OccupationText = $scope.OPBBCA.occupationText;
                $scope.CIFInvestor.Position = $scope.OPBBCA.position.key;
                $scope.CIFInvestor.PositionText = $scope.OPBBCA.positionText;
                $scope.CIFInvestor.NatureOfBusiness = $scope.OPBBCA.business.key;
                $scope.CIFInvestor.NatureOfBusinessText = $scope.OPBBCA.businessText;
            } else if ($scope.CIFInvestor.QuestionRDN == '2') {
                $scope.CIFInvestor.BankName = $scope.bankpribadi;
                $scope.CIFInvestor.Occupation = $scope.CIFInvestor.Occupation.key;
                if ($scope.CIFInvestor.Occupation == 7) {
                    $http({
                        method: 'GET',
                        url: '/service/client.svc/GetJabatanPERMATA?Pekerjaan=' + $scope.CIFInvestor.Occupation.key,
                    }).then(function (data) {
                        $scope.listjabatan_PERMATA = data.data.d;
                        $scope.OccupationText = $filter('filter')($scope.listjabatan_PERMATA, { key: $scope.CIFInvestor.Occupation }, true)[0];
                        $scope.CIFInvestor.OccupationText = OccupationText.NAMA_Pekerjaan;
                    }, function (error) { });
                }
                else {
                    $scope.CIFInvestor.OccupationText = $scope.CIFInvestor.OccupationText;
                }
                $scope.CIFInvestor.Position = $scope.CIFInvestor.Position.key;
                $scope.CIFInvestor.PositionText = $scope.CIFInvestor.PositionText;
                $scope.CIFInvestor.NatureOfBusiness = Number($scope.CIFInvestor.NatureOfBusiness);
                $scope.CIFInvestor.NatureOfBusinessText = $scope.CIFInvestor.businessText;
            } else {

                $scope.CIFInvestor.Occupation = Number($scope.OPBOTHER.occupation);
                $scope.CIFInvestor.BankName = $scope.bankpribadi;
                $scope.CIFInvestor.OccupationText = $scope.OPBOTHER.occupationText;
                $scope.CIFInvestor.Position = 0;
                $scope.CIFInvestor.NatureOfBusiness = 0;

                if ($scope.OPBOTHER.occupation == '4') {

                    $scope.CIFInvestor.PositionText = '';
                    $scope.CIFInvestor.NatureOfBusinessText = '';
                } else {

                    $scope.CIFInvestor.PositionText = $scope.OPBOTHER.positionText;
                    $scope.CIFInvestor.NatureOfBusiness = 0;
                    $scope.CIFInvestor.NatureOfBusinessText = $scope.OPBOTHER.businessText;
                }
            }

            //if ($scope.CIFInvestor.Position != '0') {
            //    $scope.CIFInvestor.PositionText = null;
            //}

            //if ($scope.CIFInvestor.NatureOfBusiness != '0') {
            //    $scope.CIFInvestor.NatureOfBusinessText = null;
            //}

            if ($scope.spouseMandatory) {

                $scope.CIFInvestor.SpouseOccupation = Number($scope.OPSPOUSE.occupation);
                $scope.CIFInvestor.SpouseOccupationText = $scope.OPSPOUSE.occupationText;
                $scope.CIFInvestor.SpousePosition = $scope.OPSPOUSE.position;
                $scope.CIFInvestor.SpouseNatureOfBusiness = ($scope.OPSPOUSE.business);
                //$scope.CIFInvestor.SpouseCompanyCity = Number($scope.SpouseCompanyCitySelected);
            } else {

                $scope.CIFInvestor.SpouseIncomePerAnnum = 0;
                $scope.CIFInvestor.SpouseIncomeExtraPerAnnum = 0;
                $scope.CIFInvestor.SpouseOccupation = 0;
                $scope.CIFInvestor.SpouseCompanyCity = 0;
            }

            if ($scope.selectedFundSource) {

                $scope.CIFInvestor.FundSource = '';

                for (var i = 0; i < $scope.selectedFundSource.length; i++) {

                    if ($scope.CIFInvestor.FundSource.length > 0)
                        $scope.CIFInvestor.FundSource += ',';
                    $scope.CIFInvestor.FundSource += $scope.selectedFundSource[i];
                }
            }


            if ($scope.selectedSpouseFundSource) {

                $scope.CIFInvestor.SpouseFundSource = '';

                for (var i = 0; i < $scope.selectedSpouseFundSource.length; i++) {

                    if ($scope.CIFInvestor.SpouseFundSource.length > 0)
                        $scope.CIFInvestor.SpouseFundSource += ',';
                    $scope.CIFInvestor.SpouseFundSource += $scope.selectedSpouseFundSource[i];
                }
            }
        };



        $scope.validationinput = function () {

            var errorForm = $scope.myForm.$error.required
            var validation = $scope.myForm.$valid;
            var message = [];
            //console.log('error :', errorForm);

            if (errorForm) {
                for (let i = 0; i < errorForm.length; i++) {
                    //message += errorForm[i].$name + " , ";
                    message.push(errorForm[i].$name);
                }
            }

            //PROSES VALIDATION
            if (validation == false) {
                console.log("error : " + message);

                var SWALtranslate = $scope.SWALtranslate('validationinput');
                Swal.fire({
                    title: SWALtranslate.title,
                    text: SWALtranslate.message,
                    imageUrl: 'img/collection/wrong.png',
                    imageAlt: 'Preparation',
                    imageHeight: 250,
                    animation: false
                });
            }

        }


        var allPromise = $q.all([

              $http({
                  method: 'GET',
                  url: '/service/client.svc/GetCIFProvinceCity',
                  cache: true,
              }).then(function (data) {

                    $scope.ListProvinceCity = data.data.d;
              }, function (error) { }),

              $http({
                  method: 'GET',
                  url: '/service/client.svc/GetCIFBank',
                  cache: true,
              }).then(function (data) {

                  $scope.ListBank = data.data.d;
              }, function (error) { }),

          
        $http({
            method: 'GET',
            url: '/service/client.svc/GetCIFLookup',
            cache: true,
        }).then(function (data) {

            $scope.ListLookup = data.data.d;

            if ($scope.ListLookup) {
                $scope.ListOccupation = $filter('filter')($scope.ListLookup, { CIFLookupID: 'Occupation' }, true);
                $scope.ListSpouseIncome = $filter('filter')($scope.ListLookup, { CIFLookupID: 'IncomePerAnnum' }, true);
                $scope.ListFundSource = $filter('filter')($scope.ListLookup, { CIFLookupID: 'FundSource' }, true);
                $scope.ListIncomePerAnnum = $filter('filter')($scope.ListLookup, { CIFLookupID: 'IncomePerAnnum' }, true);
            }
        }, function (error) { }),
        
           $http({
               method: 'GET',
               url: '/service/client.svc/GetCIFBank',
               cache: true,
           }).then(function (data) {

                    $scope.ListBank = data.data.d;
           }, function (error) { }),

            $http({
                method: 'GET',
                url: '/service/client.svc/GetCIFPekerjaan',
                cache: true,
            }).then(function (data) {
                $scope.listpekerjaan_BCA = data.data.d;
            }, function (error) { }),

            $http({
                method: 'GET',
                url: '/service/client.svc/GetJabatan',
                cache: true,
            }).then(function (data) {
                $scope.listposition_BCA = data.data.d;
            }, function (error) { }),

            $http({
                method: 'GET',
                url: '/service/client.svc/GetBidangUsaha',
                cache: true,
            }).then(function (data) {
                $scope.listnature_BCA = data.data.d;
            }, function (error) { }),

             $http({
                 method: 'GET',
                 url: '/service/client.svc/GetCIFPekerjaanPermata',
                 cache: true,
             }).then(function (data) {

                    $scope.listpekerjaan_PERMATA = data.data.d;
             }, function (error) { }),

              $http({
                  method: 'GET',
                  url: '/service/client.svc/GetJabatanPermata',
                  cache: true,
              }).then(function (data) {
                    $scope.listposition_PERMATA = data.data.d;
              }, function (error) { }),

                $http({
                    method: 'GET',
                    url: '/service/client.svc/GetBidangUsahaPermata',
                    cache: true,
                }).then(function (data) {

                    $scope.listnature_PERMATA = data.data.d;
                }, function (error) { }),

        ]);

        allPromise.then(function () {

            $http({
                method: 'GET',
                url: '/service/client.svc/getCIF',
                cache: true,
            }).then(function (data) {
                    if (data.data.d != null) {
                        var obj = data.data.d;
                        $scope.CIFInvestor = data.data.d;
                        $scope.CIFInvestor.Stage = 2;
                        if ($scope.CIFInvestor.QuestionRDN == 0) {

                            $scope.CIFInvestor.QuestionRDN = '';
                        }

                        if ($scope.CIFInvestor.BankOwner == '' || !$scope.CIFInvestor.BankOwner)
                            $scope.CIFInvestor.BankOwner = $scope.CIFInvestor.FirstName;

                        if ($scope.CIFInvestor.QuestionNPWP == 0)
                            $scope.CIFInvestor.QuestionNPWP = '';

                        $scope.bankpribadi = $scope.CIFInvestor.BankName;

                     
                        if ($scope.CIFInvestor.SpouseCompanyCity)
                            $scope.SpouseCompanyCitySelected = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: $scope.CIFInvestor.DomicileCity }, true)[0];

                        if (data.data.d.CompanyCity) {
                            $scope.CompanyCitySelected = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: data.data.d.CompanyCity }, true)[0];
                            $http({
                                method: 'GET',
                                url: '/service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + data.data.d.CompanyCity,
                                cache: true,
                            }).then(function (dataKecamatan) {
                                $scope.ListKecamatanCompany = dataKecamatan.data.d;
                                if ($scope.ListKecamatanCompany)
                                    $scope.ListKelurahanCompany = $filter('filter')($scope.ListKecamatanCompany, { Kecamatan: $scope.CIFInvestor.CompanyKecamatan }, true);

                               
                            }, function (error) { });
                        }

                      
                        if (data.data.d.SpouseBirthDate)
                            $scope.CIFInvestor.SpouseBirthDate = new Date(data.data.d.SpouseBirthDate);

                        if ($scope.CIFInvestor.QuestionRDN) {

                            //BCA
                            if ($scope.CIFInvestor.QuestionRDN == '1' || $scope.CIFInvestor.QuestionRDN == 1) {

                                $scope.OPBBCA.occupationText = $scope.CIFInvestor.OccupationText;
                                $scope.OPBBCA.positionText = $scope.CIFInvestor.PositionText;
                                $scope.OPBBCA.businessText = $scope.CIFInvestor.NatureOfBusinessText;

                                if ($scope.CIFInvestor.Occupation && $scope.CIFInvestor.Occupation > 0) {

                                    $scope.OPBBCA.occupation = $filter('filter')($scope.listpekerjaan_BCA, { key: $scope.CIFInvestor.Occupation }, true)[0];

                                   
                                    $http({
                                        method: 'GET',
                                        url: '/service/client.svc/GetJabatan?Pekerjaan=' + $scope.OPBBCA.occupation.key,
                                    }).then(function (data) {

                                            $scope.listjabatan_BCA = data.data.d;

                                            if ($scope.listjabatan_BCA.length) {

                                                if ($scope.CIFInvestor.Position && $scope.CIFInvestor.Position > 0) {

                                                    $scope.OPBBCA.position = $filter('filter')($scope.listjabatan_BCA, { key: $scope.CIFInvestor.Position }, true)[0];

                                                    $http({
                                                        method: 'GET',
                                                        url: '/service/client.svc/GetBidangUsaha?Jabatan=' + $scope.OPBBCA.position.key + '&Pekerjaan=' + $scope.OPBBCA.occupation.key,
                                                    }).then(function (data) {

                                                            $scope.listusaha_BCA = data.data.d;

                                                            if ($scope.listusaha_BCA.length) {

                                                                if ($scope.CIFInvestor.NatureOfBusiness != null)
                                                                    $scope.OPBBCA.business = $filter('filter')($scope.listusaha_BCA, { key: $scope.CIFInvestor.NatureOfBusiness }, true)[0];
                                                            }
                                                    }, function (error) { });
                                                }
                                            }
                                    }, function (error) { });
                                }

                            }
                                //PERMATA
                            else if ($scope.CIFInvestor.QuestionRDN == '2' || $scope.CIFInvestor.QuestionRDN == 2) {
                                $scope.CIFInvestor.businessText = $scope.CIFInvestor.NatureOfBusinessText;

                                if ($scope.CIFInvestor.Occupation && $scope.CIFInvestor.Occupation > 0) {

                                    $scope.CIFInvestor.Occupation = $filter('filter')($scope.listpekerjaan_PERMATA, { key: $scope.CIFInvestor.Occupation }, true)[0];

                                    
                                    $http({
                                        method: 'GET',
                                        url: '/service/client.svc/GetJabatanPermata?Pekerjaan=' + $scope.CIFInvestor.Occupation.key,
                                    }).then(function (data) {

                                            $scope.listjabatan_PERMATA = data.data.d;

                                            if ($scope.listjabatan_PERMATA.length) {

                                                if ($scope.CIFInvestor.Position && $scope.CIFInvestor.Position > 0) {

                                                    $scope.CIFInvestor.Position = $filter('filter')($scope.listjabatan_PERMATA, { key: $scope.CIFInvestor.Position }, true)[0];

                                                }
                                            }
                                    }, function (error) { });
                                }
                                if ($scope.CIFInvestor.NatureOfBusiness != null) {
                                    console.log('here');
                                    $scope.CIFInvestor.business = $filter('filter')($scope.listnature_PERMATA, { key: $scope.CIFInvestor.NatureOfBusiness }, true)[0];
                                }

                            }
                            else {

                                $scope.OPBOTHER.occupation = $scope.CIFInvestor.Occupation;
                                $scope.OPBOTHER.occupationText = $scope.CIFInvestor.OccupationText;
                                $scope.OPBOTHER.position = $scope.CIFInvestor.Position;
                                $scope.OPBOTHER.positionText = $scope.CIFInvestor.PositionText;
                                $scope.OPBOTHER.business = $scope.CIFInvestor.NatureOfBusiness;
                                $scope.OPBOTHER.businessText = $scope.CIFInvestor.NatureOfBusinessText;
                            }
                        }

                        if ($scope.CIFInvestor.SpouseCompanyCity == '')
                            $scope.CIFInvestor.SpouseCompanyCity = 0;

                        if ($scope.CIFInvestor.CompanyCity == '')
                            $scope.CIFInvestor.CompanyCity = 0;

                        if ($scope.CIFInvestor.FundSource) {

                            $scope.selectedFundSource = [];
                            let temp = $scope.CIFInvestor.FundSource.split(',');

                            for (var i = 0; i < temp.length; i++) {

                                $scope.selectedFundSource.push(Number(temp[i]));
                            }
                        }

                        if ($scope.CIFInvestor.SpouseFundSource) {

                            $scope.selectedSpouseFundSource = [];
                            let temp = $scope.CIFInvestor.SpouseFundSource.split(',');

                            for (var i = 0; i < temp.length; i++) {

                                $scope.selectedSpouseFundSource.push(Number(temp[i]));
                            }
                        }

                        if ($scope.CIFInvestor.SpouseOccupation == 0)
                            $scope.CIFInvestor.SpouseOccupation = '';


                        if ($scope.CIFInvestor.Occupation == 0 || $scope.CIFInvestor.Occupation == null)
                            $scope.CIFInvestor.Occupation = null;

                        if ($scope.CIFInvestor.business == 0 || $scope.CIFInvestor.business == null)
                            $scope.CIFInvestor.NatureOfBusiness = null;

                        if ($scope.CIFInvestor.SpouseIncomePerAnnum == 0)
                            $scope.CIFInvestor.SpouseIncomePerAnnum = '';

                        if ($scope.CIFInvestor.IncomePerAnnum == 0)
                            $scope.CIFInvestor.IncomePerAnnum = '';

                        if ($scope.CIFInvestor.SpouseIncomeExtraPerAnnum == 0)
                            $scope.CIFInvestor.SpouseIncomeExtraPerAnnum = '';


                        if ($scope.CIFInvestor.IncomeExtraPerAnnum == null)
                            $scope.CIFInvestor.IncomeExtraPerAnnum = 0;


                        $scope.changeSpouseMandatory();
                        $scope.OPSPOUSE.occupation = $scope.CIFInvestor.SpouseOccupation;
                        $scope.OPSPOUSE.occupationText = $scope.CIFInvestor.SpouseOccupationText;
                        $scope.OPSPOUSE.position = $scope.CIFInvestor.SpousePosition;
                        $scope.OPSPOUSE.business = $scope.CIFInvestor.SpouseNatureOfBusiness;
                    } // END IF data.data.d
            }, function (error) { });
        });
  
        $scope.submit = function () {
            console.log('submit');

            $scope.prepareData();

            // dynamic sweet alert post to app.js
            // 1: set the url of post or get request
            // 2: set the sweet alert translation, refers to apps.js $scope.SWALtranslate() :preconfirm = confirmation dialog before post or get request
            // 3: set the postdata to $http request = GET : {} / POST { yourdata : data }
            // 4: set the method to $http request = "GET" / "POST"
            // 5: set the sweet alert translation, refers to apps.js $scope.SWALtranslate() :preconfirm = confirmation dialog before post or get request
            // 6: if success or no error returns then...
            var urlsvc = '/service/client.svc/SaveCIF'; // 1
            var preconfirmtranslate = "submitCif2"; // 2
            var postData = { cifdata: $scope.CIFInvestor } // 3
            var method = "POST"; // 4
            $scope.PostGetSwal(preconfirmtranslate, urlsvc, postData, method, function (issuccess) {
                if (issuccess) {


                    Swal.fire({
                        title: "Preparing next step...",
                        //text: "Please wait",
                        html: `Please wait <i class="far fa-xs fa-spin fa-redo-alt"></i>`,
                        icon: "info",
                        showConfirmButton: false,
                        showCancelButton: false,
                        allowOutsideClick: false,
                        timer: 10000,
                    }).then(data => {


                        $window.location.href = "#/cif/data-pendukung";
                    })
                }
               
               
            });
        }
    }]);